import { createSlice } from "@reduxjs/toolkit";

import { GeoCalculationsJob } from "components/org-settings/models/GeoCalculations";
import { StickCalculationsJob } from "components/org-settings/models/StickCalculations";

interface IOrganizationSettings {
  isUpdateGeoCalculationJobModalOpen: boolean;
  selectedGeoCalculationJob: GeoCalculationsJob;
  selectedStickCalculationJob: StickCalculationsJob;
}

const initialState: IOrganizationSettings = {
  isUpdateGeoCalculationJobModalOpen: false,
  selectedGeoCalculationJob: undefined,
  selectedStickCalculationJob: undefined
};

const organizationSettingsSlice = createSlice({
  name: "organizationSettings",
  initialState,
  reducers: {
    setIsUpdateGeoCalculationJobModalOpen(state, action) {
      state.isUpdateGeoCalculationJobModalOpen = action.payload;
    },
    setSelectedGeoCalculationJob(state, action) {
      state.selectedGeoCalculationJob = action.payload;
    },
    setSelectedStickCalculationJob(state, action) {
      state.selectedStickCalculationJob = action.payload;
    },
    resetOrgSettingsSlice: () => initialState
  }
});

export const {
  setIsUpdateGeoCalculationJobModalOpen,
  setSelectedGeoCalculationJob,
  setSelectedStickCalculationJob,
  resetOrgSettingsSlice
} = organizationSettingsSlice.actions;

export default organizationSettingsSlice.reducer;
